import { Flex } from "@/components/Flex/Flex";

/* Inline glyphs for the next-steps cards. All decorative, all fixed artwork. */

export function ArrowIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 20"
      fill="none"
      className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5"
    >
      <path
        d="M4 10h11M11 5l5 5-5 5"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TelegramIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
      <path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71l-4.14-3.05-1.99 1.93c-.23.23-.42.42-.86.42z" />
    </svg>
  );
}

export function CheckBadge() {
  return (
    <Flex
      as="span"
      aria-hidden="true"
      align="center"
      justify="center"
      className="h-9 w-9 shrink-0 rounded-full bg-brand-content/20"
    >
      <svg aria-hidden="true" viewBox="0 0 20 20" fill="none" className="h-5 w-5">
        <path
          d="M4 10.5l3.5 3.5L16 6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Flex>
  );
}

/** Tween a number to `target` with requestAnimationFrame (easeOutCubic). Starts
 *  at 0 so SSR (0) and hydration match; jumps straight to `target` when the user
 *  prefers reduced motion or `duration <= 0` (restored state). */
